import { useTranslation } from 'react-i18next';
import { cn } from '@helpers/cn';

export interface PlaceholderImageProps {
  className?: string;
}

const PlaceholderImage = ({ className }: PlaceholderImageProps) => {
  const { t } = useTranslation();

  return (
    <img
      alt={t('placeholder')}
      src='https://assets.eye-able.com/dashboard-assets/icons/placeholder-image.png'
      className={cn('eye:h-[70px]', className)}
    />
  );
};

export default PlaceholderImage;
